<template>
	<span>
		<icon :name="iconName" style="color: 777"/> {{displayName}}
	</span>
</template>

<script>
export default {
  name: 'column-tree-item',
  props: {
    column: Object,
    showType: {
      type: Boolean,
      default: true
    }
  },
  mounted: function () {
  },
  computed: {
    displayName: function () {
      if (this.showType === false) {
        return this.column.name
      }
      let displayName = this.column.name + ' - ' + this.column.dataTypeText
      switch (this.column.dataTypeText) {
        case 'CHAR':
        case 'VARCHAR':
        case 'LONGVARCHAR':
          if (this.column.columnSize !== 2147483647) {
            displayName = displayName + '(' + this.column.columnSize + ')'
          }
          break
      }
      return displayName
    },
    iconName: function () {
      switch (this.column.dataTypeText) {
        case 'CHAR':
        case 'VARCHAR':
        case 'LONGVARCHAR':
          return 'quote-right'
        case 'SMALLINT':
        case 'INTEGER':
        case 'BIGINT':
          return 'hashtag'
        case 'REAL':
        case 'DECIMAL':
        case 'DOUBLE':
          return 'crosshairs'
        case 'TIME':
        case 'TIMESTAMP':
          return 'clock'
        case 'DATE':
          return 'calendar-alt'
      }
      return 'columns'
    }
  }
}
</script>

<style  lang="css" scoped>
</style>



// WEBPACK FOOTER //
// ColumnTreeItem.vue?572841e7